import _Object$keys from "@babel/runtime-corejs3/core-js/object/keys";
import _Object$getOwnPropertySymbols from "@babel/runtime-corejs3/core-js/object/get-own-property-symbols";
import _filterInstanceProperty from "@babel/runtime-corejs3/core-js/instance/filter";
import _Object$getOwnPropertyDescriptor from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptor";
import _Object$getOwnPropertyDescriptors from "@babel/runtime-corejs3/core-js/object/get-own-property-descriptors";
import _Object$defineProperties from "@babel/runtime-corejs3/core-js/object/define-properties";
import _Object$defineProperty from "@babel/runtime-corejs3/core-js/object/define-property";
import _defineProperty from "@babel/runtime-corejs3/helpers/defineProperty";
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = _filterInstanceProperty(o).call(o, function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from "vuex";
import { LOAD_MARKETING_TEMPLATE, UPDATE_TEMPLATE, CREATE_TEMPLATE, UPDATE_CURRENT_TEMPLATE } from "../../../../marketing/store/templates/templates-actions";
import { SAVE_CURRENT_CAMPAIGN } from "../../store/drip-campaign-actions";
import TemplateCard from "@Broker/@Modules/marketing/templates/components/template-card.vue";
import { encode64 } from "@Broker/js/custom/utils";
import Loader from "@Shared/utils/preload";
import { showToast } from "@Shared/@Utils/constants";
import HtmlTemplateEditor from "@Broker/@Modules/util-components/html-template-editor.vue";
import Amplitude from "@Shared/@Utils/amplitude";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DripCampaignTemplateSelect",
  components: {
    TemplateCard,
    HtmlTemplateEditor
  },
  props: {
    stage: {
      type: Object,
      required: true
    },
    index: {
      type: Number,
      required: true
    },
    campaignId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      bee: {},
      selectedTemplateJson: "",
      creatingTemplate: false,
      createTemplateSucceeded: true,
      showSavedMessage: false,
      previewTemplate: false,
      templateSourceUrl: ""
    };
  },
  computed: _objectSpread(_objectSpread({}, mapState("TemplatesStore", ["currentTemplate"])), {}, {
    selectTemplateParams() {
      return {
        query: {
          backPath: `/automation/drip-campaigns/${this.campaignId}`,
          fromDripCampaign: true,
          index: this.index
        }
      };
    },
    hasTemplate() {
      return this.stage.templateId;
    },
    selectorClass() {
      return this.hasTemplate ? "selector" : "selector-error clickable";
    }
  }),
  methods: _objectSpread(_objectSpread(_objectSpread({}, mapActions("DripCampaignStore", [SAVE_CURRENT_CAMPAIGN])), mapActions("TemplatesStore", [LOAD_MARKETING_TEMPLATE, UPDATE_TEMPLATE, CREATE_TEMPLATE, UPDATE_CURRENT_TEMPLATE])), {}, {
    handleTemplateEdit() {
      this.handleOpenBeeEditor("edit");
      Amplitude.logEvent("Drip Campaign - edit marketing template card clicked");
    },
    handleTemplatePreview() {
      this.handleOpenBeeEditor("preview");
      Amplitude.logEvent("Drip Campaign - preview marketing template card clicked");
    },
    handleTemplateDelete() {
      this.$emit("template-delete");
      Amplitude.logEvent("Drip Campaign - remove marketing template clicked");
    },
    async onSaveHandler({
      jsonTemplate,
      htmlTemplate
    }) {
      const json = encode64(jsonTemplate);
      const html = encode64(htmlTemplate);
      await this.UPDATE_TEMPLATE({
        templateId: this.currentTemplate.templateId,
        data: {
          json,
          html
        }
      });
      if (this.showSavedMessage) showToast("success", "templateSaved");else this.showSavedMessage = true;
      Loader.stop();
    },
    async handleOpenBeeEditor(type) {
      this.previewTemplate = type === "preview";
      this.UPDATE_CURRENT_TEMPLATE(_objectSpread(_objectSpread({}, this.currentTemplate), {}, {
        templateId: this.stage.templateId
      }));
      await this.LOAD_MARKETING_TEMPLATE(this.stage.templateId);
      await this.$nextTick();
      this.templateSourceUrl = this.currentTemplate.url;
      this.showSavedMessage = false;
      this.$refs.templateEditorContainer.mountPlugin();
    },
    handleEditorHidden() {
      this.previewTemplate = false;
      this.templateSourceUrl = "";
    },
    goSelectTemplate() {
      if (!this.hasTemplate) {
        this.SAVE_CURRENT_CAMPAIGN({
          currentStageId: this.stage.stageId
        });
        this.$router.push({
          path: "/marketing/templates",
          query: _objectSpread({
            selectPage: true
          }, this.selectTemplateParams.query)
        });
      }
    }
  })
});